import { render } from "./SurveySettingsModal.vue?vue&type=template&id=4c900772&scoped=true"
import script from "./SurveySettingsModal.vue?vue&type=script&lang=js"
export * from "./SurveySettingsModal.vue?vue&type=script&lang=js"

import "./SurveySettingsModal.vue?vue&type=style&index=0&id=4c900772&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c900772"]])

export default __exports__